(function ($) {

	var table = $('.js-table');

	if(table.length > 0 ) {

		table.each(function() {

			$(this).wrap('<div class="c-table--scrollable-wrapper"></div>')

		});

	}


})(jQuery);